'use client'

import { Button } from '@qr-front/ui/components/Button'
import { StickyOnMobileContainer } from '@qr-front/ui/components/StickyOnMobileContainer'
import { cn } from '@qr-front/ui/utils'
import { ReactNode, useEffect, useState } from 'react'

import { Link } from '@/i18n-routing'

type Props = {
	targetId: string
	href: string
	children: ReactNode
}

export const StickyMobileCtaButton = ({ targetId, href, children }: Props) => {
	const [isPastTarget, setIsPastTarget] = useState(false)

	useEffect(() => {
		const target = document.getElementById(targetId)
		if (!target) return

		const observer = new IntersectionObserver(
			([entry]) => {
				if (!entry) return
				setIsPastTarget(
					!entry.isIntersecting && entry.boundingClientRect.top < 0,
				)
			},
			{ threshold: 0 },
		)
		observer.observe(target)

		return () => observer.disconnect()
	}, [targetId])

	return (
		<StickyOnMobileContainer
			containerCls={cn(
				'transition-transform duration-300 tablet:hidden',
				isPastTarget ? 'translate-y-0' : 'translate-y-full',
			)}
			pageBottomSpacerCls="tablet:h-0"
		>
			<Button
				visual="default"
				size="large"
				pulsate
				asChild
				className="w-full"
				aria-hidden={!isPastTarget}
			>
				<Link
					href={href}
					prefetch={false}
					tabIndex={isPastTarget ? 0 : -1}
				>
					{children}
				</Link>
			</Button>
		</StickyOnMobileContainer>
	)
}
